// import { faArrowRotateRight, faCalendar } from '@fortawesome/pro-light-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { useContext } from 'react';
import { PricingContext } from '../../../../providers/pricing-provider';
import './styles.scss';

const PricingInfo = () => {
  const { triggerAllSubmits, isAnyTradeLoading } = useContext(PricingContext);

  return (
    <div className="pricing-info-container">
      {/* <span className="label">Last market data information:</span>
      <div className="datetime">
        <FontAwesomeIcon icon={faCalendar} className="icon" />
        <span>19 Oct 2023 - 20:50 UTC</span>
      </div> */}

      <Button className="btn-pricing" onClick={triggerAllSubmits} disabled={isAnyTradeLoading}>
        <span>Calculate</span>
      </Button>
    </div>
  );
};

export default PricingInfo;
